export default __webpack_public_path__ + "static/media/forgotpass.ae41dc4b.png";